import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";

import { GRACE_WINDOW_DAYS } from "../../constant";

/*
    API Access (static#49) — D16, the destructive-action confirm for rotation.

    Rotation is not instantly destructive: the plan keeps the old credentials
    alive for a 7-day grace window (GRACE_WINDOW_DAYS), deliberately deviating
    from the issue text, which said rotation "revokes old keys immediately".
    Say the concrete date out loud rather than letting the customer discover it.
*/

// Moved to src/constant — the FAQ and the Authentication guide need it too.
// Re-exported here so existing importers do not have to change.
export { GRACE_WINDOW_DAYS };

const ConfirmRotateApiKey = ({ isOpen, toggle, onConfirm, saving = false }) => {
  const [acknowledged, setAcknowledged] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setAcknowledged(false);
    }
  }, [isOpen]);

  const expectedExpiry = moment()
    .add(GRACE_WINDOW_DAYS, "days")
    .format("MMMM D, YYYY");

  return (
    <Modal
      className="contact-modal api-access-rotate"
      isOpen={!!isOpen}
      toggle={toggle}
    >
      <ModalHeader className="contact-modal__head" toggle={toggle}>
        <h4>Rotate your API key?</h4>
      </ModalHeader>
      <ModalBody className="contact-modal__modal-scrollable">
        <div
          className="api-access__alert api-access__alert--warning mb-4"
          role="alert"
        >
          <strong>Your current key stops working on {expectedExpiry}.</strong>{" "}
          That is {GRACE_WINDOW_DAYS} days from today. Update your integration
          with the new credentials before then or your API calls will start
          failing.
        </div>

        <p className="contact-modal__password-para">
          Rotating creates a brand new Access Key ID, Secret Access Key and API
          Key. Both the old and the new credentials work during the{" "}
          {GRACE_WINDOW_DAYS}-day overlap, so nothing breaks the moment you
          click — you get a window to deploy the change.
        </p>

        <ul className="mb-4">
          <li>
            Your new Secret Access Key is shown <strong>once</strong>, right
            after you confirm. Have somewhere safe to paste it.
          </li>
          <li>
            You cannot rotate again until the overlap ends — AWS allows two keys
            at a time, and the overlap uses both.
          </li>
          <li>Rotating does not change your plan, price or quota.</li>
        </ul>

        <div className="api-access__ack">
          <Input
            type="checkbox"
            id="api-access-rotate-ack"
            checked={acknowledged}
            onChange={(e) => setAcknowledged(e.target.checked)}
          />
          <Label for="api-access-rotate-ack" className="mb-0">
            I understand my current key will stop working on {expectedExpiry}.
          </Label>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          color="danger"
          onClick={onConfirm}
          disabled={!acknowledged || saving}
        >
          {saving ? <Spinner size="sm" className="mx-3" /> : "Rotate my key"}
        </Button>
        <Button
          type="button"
          color="site-lite-btn"
          onClick={toggle}
          disabled={saving}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmRotateApiKey;
